export const documentTemplateAcceptedFileTypes = [
  'image/jpeg',
  'image/png',
  '.pdf',
  '.doc',
  '.docx',
];

export const noticeAcceptedFileTypes = ['image/jpeg', 'image/png', '.pdf', '.doc', '.docx'];

export const maintenanceTicketAcceptedFileTypes = [
  'image/*',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/xls',
  'application/xlsx',
];

export const petPhotoAcceptedFileTypes = ['image/jpeg', 'image/png', 'image/jpg'];

export const imageAcceptedFileTypes = ['image/*'];

export const scheduleAAcceptedFileTypes = ['.pdf'];

export const eventPhotoAcceptedFileTypes = ['image/jpeg', 'image/png', 'image/jpg'];

export const promoPhotoAcceptedFileTypes = ['image/jpeg', 'image/png', 'image/jpg'];
